import Immutable from 'seamless-immutable';
import createReducer from '../../../helpers/createReducer';

/**
 * Help store
 */
const state = {
  bpData: {},
};

/**
 * Help reducers
 */
const bulkPickup = createReducer(state, {
  SET_BULK_PICKUP_ITEMS: (state, { data }) => Immutable({ ...state, bpData: data }),
});

export default bulkPickup;
